function allButLastDigit(value) {
  return Math.floor(value / 10);
}

export { allButLastDigit };